import { US_CITIZEN, INDIVIDUAL } from './chunk-4VKGU7BH.mjs';

// constants/inquiries.ts
var INQUIRY_APPROVED = "approved";
var INQUIRY_DECLINED = "declined";
var INQUIRY_REISSUED = "reissued";
var INQUIRY_FOR_REVIEW = "needs_review";
var INQUIRY_COMPLETED = "completed";
var INQUIRY_PENDING = "pending";
var INQUIRY_CREATED = "created";
var INQUIRY_EXPIRED = "expired";
var INQUIRY_FAILED = "failed";
var INQUIRY_RESUMED = "resumed";
var INQUIRY_FAILED_STATUSES = [
  INQUIRY_DECLINED,
  INQUIRY_FAILED,
  INQUIRY_FOR_REVIEW,
  INQUIRY_EXPIRED,
  INQUIRY_REISSUED
];
var INQUIRY_PENDING_STATUSES = [INQUIRY_PENDING, INQUIRY_CREATED, INQUIRY_RESUMED];
var INQUIRY_APPROVED_STATUSES = [INQUIRY_APPROVED, INQUIRY_COMPLETED];
var INQUIRY_STATUS_VARIANT = {
  pending: {
    text: "Pending",
    variant: "pending"
  },
  success: {
    text: "Approved",
    variant: "success"
  },
  error: {
    text: "Failed",
    variant: "error"
  },
  created: {
    text: "Started",
    variant: "unknown"
  },
  unknown: {
    text: "Not Started",
    variant: "unknown"
  }
};
var canBeSilent = (vault) => {
  if (!vault) return false;
  return vault?.citizenship === US_CITIZEN && vault?.entityType === INDIVIDUAL;
};
var INQUIRY_TYPE = {
  SILENT: "SILENT",
  KYC: "KYC",
  KYB: "KYB"
};
var INQUIRY_STATUS_TEXT = {
  [INQUIRY_COMPLETED]: "Completed",
  [INQUIRY_APPROVED]: "Approved",
  [INQUIRY_DECLINED]: "Declined",
  [INQUIRY_FOR_REVIEW]: "Needs Review",
  [INQUIRY_PENDING]: "Pending",
  [INQUIRY_CREATED]: "Created",
  [INQUIRY_EXPIRED]: "Expired",
  [INQUIRY_FAILED]: "Failed",
  [INQUIRY_REISSUED]: "Reissued",
  [INQUIRY_RESUMED]: "Resumed"
};
var INQUIRY_STATUS_CONFIG_MAP = {
  [INQUIRY_APPROVED]: {
    color: "green",
    textColor: "green.600",
    display: "APPROVED"
  },
  [INQUIRY_COMPLETED]: {
    color: "orange",
    textColor: "orange.600",
    display: "REVIEW"
  },
  [INQUIRY_FOR_REVIEW]: {
    color: "orange",
    textColor: "orange.600",
    display: "NEEDS REVIEW"
  },
  [INQUIRY_CREATED]: {
    color: "gray",
    textColor: "gray.600",
    display: "STARTED"
  },
  [INQUIRY_PENDING]: {
    color: "orange",
    textColor: "orange.600",
    display: "PENDING"
  },
  [INQUIRY_EXPIRED]: {
    color: "red",
    textColor: "red.600",
    display: "EXPIRED"
  },
  [INQUIRY_FAILED]: {
    color: "red",
    textColor: "red.600",
    display: "FAILED"
  },
  [INQUIRY_DECLINED]: {
    color: "red",
    textColor: "red.600",
    display: "DECLINED"
  },
  [INQUIRY_RESUMED]: {
    color: "gray",
    textColor: "gray.600",
    display: "RESUMED"
  },
  [INQUIRY_REISSUED]: {
    color: "red",
    textColor: "red.600",
    display: "REISSUED"
  }
};
var SCREENING_REPORT_TYPES = [
  { key: "business_lookup", typeMatch: "business-lookup", match_is_positive: true },
  { key: "adverse_media", typeMatch: "adverse-media", match_is_positive: false },
  { key: "watchlist", typeMatch: "watchlist", match_is_positive: false },
  { key: "pep", typeMatch: "politically-exposed", match_is_positive: false }
];

export { INQUIRY_APPROVED, INQUIRY_APPROVED_STATUSES, INQUIRY_COMPLETED, INQUIRY_CREATED, INQUIRY_DECLINED, INQUIRY_EXPIRED, INQUIRY_FAILED, INQUIRY_FAILED_STATUSES, INQUIRY_FOR_REVIEW, INQUIRY_PENDING, INQUIRY_PENDING_STATUSES, INQUIRY_REISSUED, INQUIRY_RESUMED, INQUIRY_STATUS_CONFIG_MAP, INQUIRY_STATUS_TEXT, INQUIRY_STATUS_VARIANT, INQUIRY_TYPE, SCREENING_REPORT_TYPES, canBeSilent };
